import { Button } from "@mui/material";
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const CopyImageButton = ({ elementId, setShowImageCopy }) => {

  return (
    <Button
      size='small'
      onClick={() => {
        var node = document.getElementById(elementId);

        node.style = 'width: auto;';

        domtoimage.toBlob(node).then(function (blob) {
          // Create ClipboardItem with blob and its type, and add to an array
          const data = [new ClipboardItem({ [blob.type]: blob })];
          // Write the data to the clipboard
          navigator.clipboard.write(data);

          setShowImageCopy(true);

          node.style = 'width: 100%;';
        })
          .catch(function (error) {
            console.error('oops, something went wrong!', error);
            node.style = 'width: 100%;';
          });
      }}
      endIcon={<ContentCopyIcon />}
    >Copy Image</Button>
  );
};

export default CopyImageButton;